import React from 'react'
import { renderToString } from 'react-dom/server'
import { Icon, l } from '@manychat/manyui'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import {
  ContainerAppearance,
  ContentContainer,
} from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import {
  FlowChartDelayBlock,
  FlowChartDelayType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartDelayBlock'

import * as styles from './Delay.styles'

const ICON_STRING = renderToString(<Icon.Time color="#6449E3" size={64} />)

export const DelayGenericBlock: BlockComponent<FlowChartDelayBlock> = ({ block }) => {
  const {
    data: { delay, delayType },
  } = block

  const delayText =
    delayType === FlowChartDelayType.TYPING
      ? l.translate('Typing {time} sec...', { time: delay })
      : l.translate('Waiting {time} sec...', { time: delay })

  return (
    <InteractiveBlockContainer id={block.id}>
      <ContentContainer style={styles.BlockStyle} appearance={ContainerAppearance.DELAY}>
        <TextWithIcon icon={ICON_STRING} row>
          {delayText}
        </TextWithIcon>
      </ContentContainer>
    </InteractiveBlockContainer>
  )
}
